import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import { useEffect, useState } from "react"
import MaterialButton from "../../../components/MaterialButton"
import { useKeyValueFormHandling } from "./components/KeyValueStateHandle"
import { fetchData, fetchDataById, postData, putData } from "../../../services"
import MaterialSelect from "../../../components/MasterSelect"
import { useLoading } from "../../../components/Loading"
import { useSnackbar } from "../../../context/popup"


const KeyValueForm = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const paramId = searchParams.get("id");
  const pageType = searchParams.get("pageType");
  const pageMode = pageType === "view" ? "view" 
  : pageType === "edit" ? "edit" : "add";
  const { category, categoryId } = location.state || {};
  
  const [parentKeyOptions, setParentKeyOptions] = useState([]);

  const { formData, setFormData, handleChange, checkAllFields } = useKeyValueFormHandling();
  
  useEffect(() => {

    if(!paramId){
      return;
    }
    //get by id api
    const fetchKeyValueDataById = async () => {
    
        if (paramId) {
          setCircleLoading(true);
          try {
            await fetchDataById(`/reference/general/key-value-store/${paramId}`).then((res) => {
              if (res?.success && res?.data) {
                const data = res.data;
                  setFormData({
                    categoryId: data.category?.id || "",
                    categoryName: data.category?.categoryName || "",
                    keyName: data.keyName || "",
                    sortOrder: data.sortOrder ?? "",
                    parentKeyId: data.parentKeyId || "",
                    active: data.isActive ?? true,
                    keyNameStatus: data.keyName ? "success" : "error",
                  });
              }
              else {
                  console.error("Unexpected API response:", res);
              }
            });
          } catch (error) {
            console.error(error);
          } finally {
              setCircleLoading(false);
          }
        }
    }
    fetchKeyValueDataById();
  },[paramId])

  useEffect(() => {
    // guard: only update if redux has data
    if (categoryId && category) {
      setFormData((prev) => ({
        ...prev,
        categoryId,
        categoryName: category,
      }));
    }
  }, [categoryId, category]); 

  useEffect(() => {
    if(!categoryId){
      return;
    }
    const fetchParentKeyDropdown = async () => {
      try{
        const response = await fetchData(`/reference/general/key-value-store?categoryId=${categoryId}&dropdown=true&isActive=true`) 
        const mappedOptions = response?.data?.items?.map((item) => ({
          label: item.keyName, // display name
          value: item.id,      // underlying ID
        })) || [];

        setParentKeyOptions(mappedOptions)
      }
      catch(error){
        console.error("Error fetching key values",error);
      }
    }
    fetchParentKeyDropdown();
  },[categoryId])

  //handle submit api function

  const handleAddKeyValue = async () => {

    const payload = { 
      categoryId: categoryId,
      keyName: formData?.keyName,
      parentKeyId: formData?.parentKeyId?.value ? formData?.parentKeyId?.value : null,
      sortOrder: Number(formData?.sortOrder),
      isActive: formData?.active
    };
    //update
    if(paramId){
      try {
        const response = await putData(`/reference/general/key-value-store/${paramId}`, payload);
        if(response.success){
          showSnackbar(response?.message,"success");
          navigate("/general-master/category-list");
        }
        else{
          showSnackbar(response?.message,"error");
        }
      } catch (error) {
        console.error("Error Updating",error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      }
    }

    try {
      const response = await postData('/reference/general/key-value-store', payload);
      const successResponse = response?.success;
      const responseMessage = response?.message;
      if(successResponse){
        showSnackbar(responseMessage,"success");
        navigate("/general-master/category-list");
      }
      else{
        showSnackbar(responseMessage,"error");
      }
    } catch (error) {
      console.error('Error posting data:', error);
      showSnackbar(error?.response?.data?.message || "Network Error", "error");
    }
  };
  

  return (
    <DashboardLayout>
      <>
        <CardHeader
        title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/general-master/category-list")}>
                      <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        {formData?.categoryName} Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New {formData?.categoryName} Details for the respective Category.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        )}
        />
        <CardContent>
          <Grid2 container spacing={1} alignItems="center">
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                >
                  {formData?.categoryName}*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
              name="keyName"
              value={formData.keyName}
              onChange={handleChange}
              success={formData?.keyNameStatus === "success"}
              error={formData?.keyNameStatus === "error"}
              disabled={pageMode === "view"}
              />
              {formData.keyNameStatus === "error" && (
                  <FormControl error>
                      <FormHelperText>
                      {category} name should be a minimum 1 character & maximum 240 characters long.
                      </FormHelperText>
                  </FormControl>
              )}
            </Grid2>
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                >
                  Sort Order
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
              name="sortOrder"
              value={formData.sortOrder}
              onChange={handleChange}
              disabled={pageMode === "view"}
              />
            </Grid2>
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                >
                  Parent Key ID
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
              name="parentKeyId"
              value={formData.parentKeyId}
              onChange={handleChange}
              options={parentKeyOptions}
              success={formData.parentKeyIdStatus === "success"}
              error={formData.parentKeyIdStatus === "error"}
              isDisabled={pageMode === "view"}
              />
            </Grid2>
            <Grid2 size={{lg:2, md:2, sm: 6, xs: 12 }}>
              <MaterialBox>
                  <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold">
                      Active
                  </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
              control={
                  <Switch
                      checked={formData.active}
                      onChange={(e) =>
                          setFormData((prev) => ({
                          ...prev,
                          active: e.target.checked,
                          }))
                      }                            
                      color="primary"
                      disabled={pageMode === "view"}
                  />
              }
              label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                      {formData?.active ? "Yes" : "No"}
                  </MaterialTypography>
              }
              sx={{ marginLeft: 0 }}
              />
            </Grid2>
          </Grid2>
        </CardContent>
       
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
          {pageMode === "add" && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/general-master/category-list")}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddKeyValue}
              >
                Submit
              </MaterialButton>
            </>
          )}
          {pageMode==="edit" && (
            <>
              <MaterialButton
              variant="outlined"
              color="dark"
              sx={{ m: 2 }}
              onClick={() => navigate("/general-master/category-list")}
              >
              Cancel
              </MaterialButton>
              <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddKeyValue}
              >
              Update
              </MaterialButton>
            </>
          )}
        </MaterialBox>
       
      
      </>
    </DashboardLayout>
  )
}

export default KeyValueForm